export function shortenStringMiddle(str: string) {
  return str.length <= 12 ? str : str.slice(0, 6) + '...' + str.slice(str.length - 4)
}

export const shortenStringMiddle2 = (fullStr: string, strLen: number, separator = '...') => {
  if (fullStr.length <= strLen) return fullStr

  const sepLen = separator.length
  const charsToShow = strLen - sepLen
  const frontChars = Math.ceil(charsToShow / 2)
  const backChars = Math.floor(charsToShow / 2)

  return (
    fullStr.substring(0, frontChars) + separator + fullStr.substring(fullStr.length - backChars)
  )
}

export const handleShowWalletAddress = (
  address: string,
  media: {
    isMMobile: boolean
    isLMobile: boolean
    isSMobile: boolean
    isSTablet: boolean
  },
): string => {
  if (!address) return ''

  if (media.isSMobile) {
    return `${address.slice(0, 12)}...${address.slice(-4)}`
  } else if (media.isMMobile) {
    return `${address.slice(0, 18)}...${address.slice(-4)}`
  } else if (media.isLMobile) {
    return `${address.slice(0, 25)}...${address.slice(-4)}`
  } else if (media.isSTablet) {
    return `${address.slice(0, 30)}...${address.slice(-4)}`
  }

  return address
}
